'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var useOrderTracking = require('@narvar/nth-hook-order-tracking');
var useTrackQualityCarrierLogo = require('./hooks/useTrackQualityCarrierLogo.js');
var nthHookGrowthbook = require('@narvar/nth-hook-growthbook');
var useLogTrackingNumberInteraction = require('./hooks/useLogTrackingNumberInteraction.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);
var useOrderTracking__default = /*#__PURE__*/_interopDefaultLegacy(useOrderTracking);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const trackingNumberId = 'tracking-number';
const CarrierTrackingLink = ({
  featureName,
  layout = FeatureLayout.PORTRAIT
}) => {
  const {
    enabled: eddExperimentEnabled
  } = nthHookGrowthbook.useIsTrackFeatureOn('edd-recency');
  const {
    enabled: eddConfidenceHypothesis1Enabled
  } = nthHookGrowthbook.useIsTrackFeatureOn('edd-confidence-hypothesis-1');
  const {
    bodytextDefaultNone: bodyTextStyle,
    linksTrackingDefault: linkStyle,
    linksTrackingHover: linkHoverStyle
  } = nthHookTheme.useTheme();
  const {
    shippingActivityTrackingNumberText
  } = nthHookTranslations.useTranslations();
  const {
    getCurrentShipment
  } = useOrderTracking__default["default"]();
  const currentShipment = getCurrentShipment();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const {
    ref: imgRef,
    clientCarrierLogo
  } = useTrackQualityCarrierLogo.useTrackQualityCarrierLogo(currentShipment);
  const {
    trackingNumber = '',
    trackingUrl = '',
    carrier,
    history = [],
    carrierLogoUrl,
    lastUpdate = ''
  } = currentShipment ?? {};
  useLogTrackingNumberInteraction.useLogTrackingNumberInteraction({
    id: trackingNumberId,
    featureName,
    layout,
    carrier: carrier ?? '',
    trackingNumber: trackingNumber ?? '',
    eddConfidenceHypothesis1Enabled
  });
  if (!currentShipment) return null;
  if (!trackingNumber) return null;
  let lastUpdateText = `You're seeing all information provided by ${carrier || 'the carrier'}. `;
  if (eddExperimentEnabled) {
    const lastHistory = history.find(event => event.date === lastUpdate);
    const {
      dateFormatted
    } = lastHistory || {};
    const formattedLastUpdate = dateFormatted && dateFormatted[0] && `${dateFormatted[0]}${dateFormatted[1] ? ', ' + dateFormatted[1] : ''}`;
    lastUpdateText += formattedLastUpdate ? `The latest update was ${formattedLastUpdate}.` : '';
  }
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      height: '2.5rem',
      paddingRight: '0.5rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    ref: imgRef
    // `carrierLogoUrl` is nullable on the orderTracking query because of
    // scenarios like preship and bopis. However, it will be populated with
    // at least a the generic logo url in every other case.
    ,
    src: clientCarrierLogo ?? carrierLogoUrl ?? '',
    alt: `${carrier ?? ''}`,
    style: {
      maxHeight: '2.5rem'
    }
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    "data-test": "shippingHistoryTrackingNumberText",
    style: {
      display: 'inline-block',
      verticalAlign: 'middle',
      wordBreak: 'break-all',
      ...bodyTextStyle
    }
  }, shippingActivityTrackingNumberText, /*#__PURE__*/React__default["default"].createElement("br", null), trackingUrl && !eddConfidenceHypothesis1Enabled ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    target: TextLink.TextLinkTargetType.BLANK,
    linkStyle: {
      sDefault: linkStyle,
      sHover: linkHoverStyle
    },
    href: trackingUrl,
    onClick: () => logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.EXTERNAL_TRACKING_LINK,
      clickLinkDestinationUrl: trackingUrl,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.EXTERNAL_TRACKING_LINK,
      clickType: nthHookContextAnalytics.NarvarClickTypes.OUTGOING,
      eventCarrierMoniker: carrier,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_SHIPPING_ACTIVITY,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_SHIPPING_ACTIVITY,
      eventTrackingNumber: trackingNumber,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_SHIPPING_ACTIVITY,
      trackLayout: layout
    })
  }, trackingNumber), eddExperimentEnabled && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      ...bodyTextStyle,
      fontWeight: 'bold',
      marginTop: '0.5rem',
      wordBreak: 'break-word'
    }
  }, lastUpdateText)) : /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      ...bodyTextStyle,
      fontSize: '0.875rem',
      lineHeight: '1.25rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    id: trackingNumberId
  }, trackingNumber))));
};
var index = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(CarrierTrackingLink, {
  themeTokens: ['bodytextDefaultNone', 'linksTrackingDefault', 'linksTrackingHover']
}), {
  translationKeys: ['shippingActivityTrackingNumberText']
});

exports["default"] = index;
